export default "__VITE_ASSET__f466ca18__"